import { useNavigate } from 'react-router-dom';
import type { Ticket } from '../types';
import { activityLabel, mobileTab, workPhase } from '../lib/workflow';
import { ServerTimer } from './ServerTimer';

function equipmentTitle(ticket: Ticket, fallback: string): string {
  const code = String(ticket.deviceCode || '').trim();
  const name = String(ticket.deviceName || '').trim();
  if (!code) return name || fallback;
  if (!name || name.toLocaleLowerCase('ro-RO').includes(code.toLocaleLowerCase('ro-RO'))) return name || code;
  return `${code} ${name}`;
}

export function TicketHeader({ ticket, title, activeTimer = false }: { ticket: Ticket; title?: string; activeTimer?: boolean }) {
  const navigate = useNavigate(); const tab = mobileTab(ticket); const phase = workPhase(ticket);
  const legacyNumber = [ticket.nr, ticket.number, ticket.numar].find((value) => value !== null && value !== undefined && String(value).trim()) as string | number | undefined;
  const displayNumber = ticket.ticketNumber ?? legacyNumber ?? ticket.ticketId;
  const fallback = `Tichet #${displayNumber}`;
  if (activeTimer) {
    return <header className="page-header page-header--active-timer"><button className="back" onClick={() => navigate(-1)} aria-label="Înapoi">←</button><div className="page-header__identity"><small>{activityLabel(ticket)} · ÎN LUCRU</small><h1>{equipmentTitle(ticket, fallback)}</h1></div><div className="header-live-timer"><small>TIMP</small><strong><ServerTimer ticket={ticket} /></strong></div></header>;
  }
  return <header className="page-header"><button className="back" onClick={() => navigate(-1)} aria-label="Înapoi">←</button><div><small>{title || fallback}</small><h1>{ticket.deviceName || fallback}</h1></div><div className="header-pills"><span className={`status status-${tab}`}>{tab === 'new' ? 'Nou' : tab === 'in_progress' ? 'În lucru' : 'Finalizat'}</span>{phase && <span className="phase">{activityLabel(ticket)}</span>}</div></header>;
}
